import { allowLinkingSegmentsToViews } from '@gonfalon/dogfood-flags/dogfood-flags';

import { type Segment } from './records/Segment';

// Helper function to serialize segment with conditional viewKeys removal
export function serializeSegmentForAPI(segment: Segment) {
  const js = segment.toJS();

  // Remove viewKeys for older release phases
  if (!allowLinkingSegmentsToViews()) {
    delete js.viewKeys;
  }

  return js;
}
